import React from 'react';
import SharedFilters from '../common/SharedFilters';

const PrmFilter = () => {
  return (
    <>
      <SharedFilters />
    </>
  );
};

export default PrmFilter;
